<template>
    <b-card>
        <b-card-body>
            <h4>Registration Information</h4>


            <div v-if="registration.meta && registration.meta.length" class="mt-5">
                <h4 class="mb-4">Additional Information</h4>

                <div v-for="meta in registration.meta" class="mt-3">
                    <div><strong>{{meta.title}}</strong></div>
                    <div>{{meta.value}}</div>
                </div>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "reg-information",
        props: ['reg', 'id', 'code'],
        data: function () {
            return {
                registration: {
                    conference: {},
                    fee: {}
                },
            }
        },
        methods: {
            ...mapActions(['getRegistrationByCode']),
        },
        mounted: function () {

        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';


</style>
